import type { WithActiveBranchId } from '@app/api/shared';
import type { NFiles } from '@app/types';

export enum MessageTemplatesEndpoints {
  Update = 'Update',
  Delete = 'Delete',
  SearchForSystem = 'SearchForSystem',
  Search = 'Search',
  GetSearchResult = 'GetSearchResult',
  Get = 'Get',
  AttachFiles = 'AttachFiles',
  RemoveFiles = 'RemoveFiles',
  GetFiles = 'GetFiles',
}

export interface ModelUpdateMessageTemplate {
  Id: number | null;
  Message: string | null;
  Name: string | null;
}

export interface ModelMessageTemplate {
  Id: number;
  CreatedAt: string;
  LastUpdated: string;
  Message: string | null;
  Name: string | null;
  FileIds: number[] | null;
}

export interface ModelMessageTemplateLite {
  Id: number;
  Message: string | null;
  Name: string | null;
  FileIds: number[] | null;
}

export interface ModelMessageTemplateSearchFilter {
  SearchTerm: string | null;
  MessageTemplatesPerPage: number;
}

export interface ModelMessageTemplateSearchResult {
  Id: number;
  Filter: ModelMessageTemplateSearchFilter;
  MessageTemplates: ModelMessageTemplate[] | null;
  Page: number;
  CountPages: number;
  CountMessageTemplates: number;
}

export interface ModelAttachFilesToMessageTemplate {
  Id: number;
  Files: NFiles.ModelFile[] | null;
}

export interface ModelRemoveFilesToMessageTemplate {
  Id: number;
  FileIds: number[] | null;
}

export interface ModelGetFilesMessageTemplateData {
  MessageTemplateId: number;
  FileIds: number[] | null;
}

export interface ModelGetFilesMessageTemplate {
  MessageTemplates: ModelGetFilesMessageTemplateData[] | null;
}

export interface ModelMessageTemplateFile {
  Id: number;
  Files: NFiles.ModelFile[] | null;
}

export interface ModelMessageTemplateWithFiles {
  MessageTemplates: ModelMessageTemplateFile[] | null;
}

export type UpdateMessageTemplateRequest = WithActiveBranchId<{
  data: ModelUpdateMessageTemplate;
}>;

export type DeleteMessageTemplateRequest = WithActiveBranchId<{
  data: number[];
}>;

export type SearchForSystemMessageTemplatesRequest = WithActiveBranchId<{
  search?: string;
  count?: number;
}>;

export type SearchMessageTemplatesRequest = WithActiveBranchId<{
  data: ModelMessageTemplateSearchFilter;
}>;

export type GetMessageTemplatesSearchResultRequest = WithActiveBranchId<{
  searchId: number;
  page: number;
  rowsPerPage: number;
}>;

export type GetMessageTemplateRequest = WithActiveBranchId<{
  id: number;
}>;

export type AttachFilesToMessageTemplateRequest = WithActiveBranchId<{
  data: ModelAttachFilesToMessageTemplate;
}>;

export type RemoveFilesFromMessageTemplateRequest = WithActiveBranchId<{
  data: ModelRemoveFilesToMessageTemplate;
}>;

export type GetFilesMessageTemplateRequest = WithActiveBranchId<{
  data: ModelGetFilesMessageTemplate;
}>;

export type UpdateMessageTemplateResponse = ModelMessageTemplate;
export type DeleteMessageTemplateResponse = number[];
export type SearchForSystemMessageTemplatesResponse =
  ModelMessageTemplateLite[];
export type SearchMessageTemplatesResponse = ModelMessageTemplateSearchResult;
export type GetMessageTemplatesSearchResultResponse =
  ModelMessageTemplateSearchResult;
export type GetMessageTemplateResponse = ModelMessageTemplate;
export type AttachFilesToMessageTemplateResponse = ModelMessageTemplate;
export type RemoveFilesFromMessageTemplateResponse = void;
export type GetFilesMessageTemplateResponse = ModelMessageTemplateWithFiles;
